/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const invoicePayments = sqliteTable('invoice_payments', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  invoice_id: text('invoice_id'),
  patient_id: text('patient_id'),
  amount_cents: integer('amount_cents'),
  method: text('method'),
  notes: text('notes'),
  allocations: text('allocations'),
  paid_at: text('paid_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
